import { ArrowRightIcon } from 'lucide-react'
import { useNavigate } from 'react-router'

import { EmployerOnboardingPage } from 'components/hooks/employer_onboarding/useOnboardingStep'
import { Button, usePageTitle } from 'slab'

import { CenteredLayout } from './CenteredLayout'

export function EditAllowancesPage () {
  usePageTitle('Edit allowances')

  const navigate = useNavigate()

  const handleContinue = () => {
    navigate(EmployerOnboardingPage.QUOTE)
  }

  return (
    <CenteredLayout verticallyCentered>
      <CenteredLayout.Header
        heading='Welcome back'
        subheading='You can review your allowance selections and make changes until you invite employees to sign up with Thatch.'
      />
      <CenteredLayout.Buttons>
        <Button
          variant='primary'
          onClick={handleContinue}
          size='large'
          width='auto'
          rightIcon={ArrowRightIcon}
        >
          Review your allowances
        </Button>
      </CenteredLayout.Buttons>
    </CenteredLayout>
  )
}
